import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import DescriptionItem from './DescriptionItem'
import { DescriptionItemProps } from './DescriptionItem'

type InfoPointsBlockProps = {
  onClickCta: () => void
  showCompleteAccount?: boolean
  showButton?: boolean
}

const InfoPointsBlock = ({ onClickCta, showCompleteAccount, showButton }: InfoPointsBlockProps) => {
  const onboardingItemsFirstLine: DescriptionItemProps[] = [
    {
      icon: 'add-block',
      title: i18n.t(
        'it_management.initial_setup.info_points_block.software_management_point.title'
      ),
      description: i18n.t(
        'it_management.initial_setup.info_points_block.software_management_point.description'
      ),
    },
    {
      icon: 'finance-shopping-abacus',
      title: i18n.t('it_management.initial_setup.info_points_block.financial_point.title'),
      description: i18n.t(
        'it_management.initial_setup.info_points_block.financial_point.description'
      ),
    },
    {
      icon: 'single-neutral-actions-process',
      title: i18n.t('it_management.initial_setup.info_points_block.approvals_point.title'),
      description: i18n.t(
        'it_management.initial_setup.info_points_block.approvals_point.description'
      ),
    },
  ]
  const onboardingItemsSecondLine: DescriptionItemProps[] = [
    {
      icon: 'user-male-female',
      title: i18n.t('it_management.initial_setup.info_points_block.cost_employee_point.title'),
      description: i18n.t(
        'it_management.initial_setup.info_points_block.cost_employee_point.description'
      ),
    },
    {
      icon: 'credit-card',
      title: i18n.t('it_management.initial_setup.info_points_block.payments_point.title'),
      description: i18n.t(
        'it_management.initial_setup.info_points_block.payments_point.description'
      ),
    },
    {
      icon: 'money-bag',
      title: i18n.t('it_management.initial_setup.info_points_block.cost_evolution_point.title'),
      description: i18n.t(
        'it_management.initial_setup.info_points_block.cost_evolution_point.description'
      ),
    },
  ]

  return (
    <Box alignItems="center" textAlign="center" paddingX="s64" paddingY="s32" gap="s32">
      <Box gap="s8" maxWidth="s600">
        <Text weight="semibold" size="500" color="grey1000">
          {i18n.t('it_management.initial_setup.info_points_block.title')}
        </Text>
        <Text.Normal weight="medium">
          {i18n.t('it_management.initial_setup.info_points_block.description')}
        </Text.Normal>
      </Box>

      <Box gap="s24" maxWidth="narrowPage">
        <Box flexDirection="row" alignItems="flexStart" justifyContent="center" gap="s64">
          {onboardingItemsFirstLine.map((item) => {
            return <DescriptionItem key={item.title} {...item} />
          })}
        </Box>
        <Box flexDirection="row" alignItems="flexStart" justifyContent="center" gap="s64">
          {onboardingItemsSecondLine.map((item) => {
            return <DescriptionItem key={item.title} {...item} />
          })}
        </Box>
      </Box>
      {showButton && (
        <Button onClick={onClickCta}>
          {showCompleteAccount
            ? i18n.t('it_management.initial_setup.get_started_block.cta_complete')
            : i18n.t('it_management.initial_setup.get_started_block.cta')}
        </Button>
      )}
    </Box>
  )
}

export default InfoPointsBlock
